import { useMemo, useState } from 'react'

import { useAppSelector } from '@user/store/hooks'

import {
  selectAllEntityAppointments,
  useGetEntityAppointmentsOnMount,
} from '@user/store/scheduling'
import type { MenuState } from '../typings'
import { filterByEntity } from '@sales-center/common'
import type { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function useData(props: Props) {
  const { entityId, entityType } = props

  const [menuState, setMenuState] = useState<MenuState>(() => ({
    anchorEl: null,
  }))

  const apptStatus = useGetEntityAppointmentsOnMount(entityId, entityType)

  const loading = apptStatus === 'pending'

  const allAppointments = useAppSelector(selectAllEntityAppointments)

  const appointments = useMemo(
    () => filterByEntity(allAppointments, entityId, entityType),
    [allAppointments, entityId, entityType],
  )

  return {
    ...menuState,
    loading,
    setMenuState,
    appointments,
  }
}

export type UseData = ReturnType<typeof useData>
